'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtLocationMediaReviewUpload', [
	function () {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				place: '=pmtLocationMediaReviewUpload',
				onUpdate: '<',
				onClose: '&',
				openDialog: '=',
				network: '='
			},
			link: function (scope /*, element, attrs*/) {
				scope.fileSelectionIsDone = function (file, locations) {
					scope.onUpdate(file._id.toString(), locations[0]);
				};

				scope.$watch('openDialog', function (newVal /*, oldVal*/) {
					if (newVal) {
						scope.showSavingProgress = false;
						scope.showErrorSaving = false;
						scope.placeId = scope.place._id;
					}
				});
			},
			templateUrl: 'shared/location/edit/mediaReviewUpload/pmtLocationMediaReviewUploadView.html'
		};
	}
]);
